import type { UseListProps, UseListResult } from '@ztechapps/common.hook'
import type { Chat } from '@ztechapps/common.contract'
import { useChatMessageList } from './useChatMessageList'
import type { SetOptional } from 'type-fest'
import { allChatQuery } from './graphql'

export type UseChatMessageListByUserEmailProps = {
  email: string
} & SetOptional<UseListProps, 'query'>

export const useChatMessageListByUserEmail = (
  { email, query, ...rest } = {} as UseChatMessageListByUserEmailProps
): UseListResult<Chat> => {
  query ??= allChatQuery
  let filter: any = {
    status: { $ne: 'deleted' },
  }
  //include the email on the filter — the CC list is the conversation's participant list
  //(`Chat.collaborators` is retired), so a copied-in participant matches here
  if (email) {
    filter = {
      ...filter,
      $or: [{ ccEmails: email }, { 'sender.profile.email': email }],
    }
  }

  return useChatMessageList({ filter, query, ...rest })
}
